'use client';
import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { usePathname } from '@/navigation';
import { useSetAtom } from 'jotai';

import { routeReferrerAtom, ROUTE_REFERRER_SESSION_KEY } from '@/atoms/route-referrer';

export const RouteTracker = () => {
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const setReferrer = useSetAtom(routeReferrerAtom);

	useEffect(() => {
		if (!pathname) return;
		
		const isPromotionPage = pathname.startsWith('/wc-promotion');
		const isTournamentPage = pathname.startsWith('/tournament');
		
		if (!isPromotionPage && !isTournamentPage) {
			const currentUrl = searchParams.toString() 
				? `${pathname}?${searchParams.toString()}` 
				: pathname;
			setReferrer(currentUrl);
			sessionStorage.setItem(ROUTE_REFERRER_SESSION_KEY, currentUrl);
		}

	}, [pathname, searchParams]);

	return null;
};